import { z } from 'zod'

// Mirrors the BE's `LinkedDocumentMetadata` shape without review fields. Used for
// related-cases responses. Case citations and citing cases parse with
// `CitingCaseSchema` in `case-review-schema.ts` so optional `review_label` /
// `explanation` survive validation.
export const CitationMetadataSchema = z.object({
  short_summary: z.string().nullable().optional(),
  case_status: z.string().nullable().optional(),
  name: z.string().describe('The name of the document.'),
  document_type: z.string().describe("The type of document: either 'law' or 'caselaw'."),
  citation: z.string().optional().nullable().describe('The citation string for the document (optional).'),
  bb_citation: z.string().optional().nullable().describe('The Bluebook citation string for the document (optional).'),
  parent_id: z.string().optional().nullable().describe('The ID of the parent document (optional).'),
  jurisdiction: z.string().optional().nullable().describe('The jurisdiction of the document (optional).'),
  text: z.string().optional().nullable().describe('The text content of the document (optional).'),
  s3_path: z.string().nullable().describe('The S3 storage path of the document, or null for an unmatched citation.'),
})
export type CitationMetadata = z.infer<typeof CitationMetadataSchema>

export const CitatorCasesResponseSchema = z.array(CitationMetadataSchema)
export type CitatorCasesResponse = z.infer<typeof CitatorCasesResponseSchema>
